<template>
  <Modal
    :id="'cmp-catalog-tracks-advanced_search'"
    :loading="loading"
    @cancelled="onCancel"
  >
    <template slot="header">{{ $t("tracks_advanced_search") }}</template>

    <template slot="body">
      <div class="body-container">
        <div class="form-group">
          <!-- Account
          Status
          accounted
          Month
          betweenand
          Del Date
          shipped
          Order Reference -->
          <Dropdown
            :id="'account_id'"
            class="m2"
            :options="advancedSearchData.accountsTV || []"
            :selected="
              advancedSearchData.accountsTV.find((t) => t.value == account_id)
            "
            :placeholder="$t('account')"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('account_id', e)"
            :listHeight="250"
          ></Dropdown>
          <Dropdown
            :id="'status'"
            class="m2"
            :options="advancedSearchData.orderStatusTV || []"
            :selected="
              advancedSearchData.orderStatusTV.find((t) => t.value == status)
            "
            :placeholder="$t('status')"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('status', e)"
            :listHeight="250"
          ></Dropdown>
          <Dropdown
            :id="'accounted_period'"
            class="m2"
            :options="advancedSearchData.accountedTV || []"
            :selected="
              advancedSearchData.accountedTV.find(
                (t) => t.value == accounted_period
              )
            "
            :placeholder="$t('accounted')"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('accounted_period', e)"
            :listHeight="250"
          ></Dropdown>
          <Dropdown
            :id="'order_month'"
            class="m2"
            :options="advancedSearchData.monthsTV || []"
            :selected="
              advancedSearchData.monthsTV.find((t) => t.value == order_month)
            "
            :placeholder="$t('month')"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('order_month', e)"
            :listHeight="250"
          ></Dropdown>
          <div class="ut-flex">
            <TextField
              type="date"
              id="order_date_start"
              style="
                margin-left: 0px !important;
                margin-right: 5px !important;
                flex: 1;
              "
              class="m1"
              :placeholder="`${$t('between')}`"
              :value="order_date_start"
              :showImmediate="true"
              autocomplete="off"
              @valuechanged="onDateChange"
            />
            <TextField
              type="date"
              id="order_date_end"
              style="
                margin-right: 0px !important;
                margin-left: 5px !important;
                flex: 1;
              "
              class="m1"
              :placeholder="`${$t('and')}`"
              :value="order_date_end"
              :showImmediate="true"
              autocomplete="off"
              @valuechanged="onDateChange"
            />
          </div>
          <TextField
            type="date"
            id="shipping_date"
            class="m1"
            :placeholder="`${$t('del_date')}`"
            :value="shipping_date"
            :showImmediate="true"
            autocomplete="off"
            @valuechanged="onDateChange"
          />
          <Dropdown
            :id="'is_shipped'"
            class="m2"
            :options="advancedSearchData.shippedTV || []"
            :selected="
              advancedSearchData.shippedTV.find((t) => t.value == is_shipped)
            "
            :placeholder="$t('shipped')"
            box
            deselect
            @selectedChange="(e) => onDropdownChange('is_shipped', e)"
            :listHeight="250"
          ></Dropdown>
          <TextField
            :id="'order_reference'"
            class="m1"
            v-bind="textFieldConfig"
            v-model="order_reference"
            isModel
            :placeholder="$t('order_reference')"
            @valuechanged="onTextFieldValueChange"
          />
        </div>
      </div>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $t("cancel") }}
      </button>
      <button
        class="dt-button s6 v1"
        :disabled="loading"
        :class="{
          disabled: loading,
        }"
        @click.stop="onSearch"
      >
        {{ $t("search") }}
      </button>
    </template>
  </Modal>
</template>

<script>
import FileDownload from "js-file-download";
// import { TracksService } from "../../services/tracks.service";

import {
  ensureBoolIntObjectFromKeys,
  ensureStringObject,
  ensureStringObjectFromKeys,
  keyValuesToObj,
} from "../../../../utility/fp";
import { createAdvancedSearchModal } from "../../../../dt-plugins/advanced-search/advance-search.mixin";
import { createAdvancedSearchConfig } from "../../../../dt-plugins/advanced-search/advanced-search.model";
import { convertDateYYYYMMDD } from '../../../../utility/dateconvert';

export const orderListAdvancedSearchConfig = createAdvancedSearchConfig({
  searchConfigStringKeys: [
    "account_id",
    "status",
    "accounted_period",
    "order_month",
    "order_date_start",
    "order_date_end",
    "shipping_date",
    "is_shipped",
    "order_reference",
  ],
  // searchConfigIntKeys: [
  //   "composer_missing",
  //   "writer_missing",
  //   "publisher_missing",
  //   "producer_missing",
  //   "arranger_missing",
  // ],
  // booleanSearchKeyLabelMap: {
  //   isrc_error: "ISRC Error",
  //   missing_main_product: "Missing Main Product",
  //   product_track_mismatch: "Product Track Mismatch",
  //   no_contract: "No Contract",
  //   playtime_missing: "Playtime is missing",
  // },

  // searchConfigTVMap: [
  //   ["track_type", "tracksTypeTV"],
  //   ["digital_right", "digitalRightTpyesTV"],
  //   ["licence_account", "licensorsTV"],
  //   ["main_label", "labelsTV"],
  //   ["any_label", "labelsTV"],
  //   ["royalty_period", "royaltyPeriodsTV"],
  //   ["invoice_project", "royaltyInvoiceProjectTV"],
  //   ["royalty_account", "royaltyAccountsTV"],
  //   ["metadata_field1", "metaDataTV"],
  //   ["metadata_field2", "metaDataTV"],
  //   ["metadata_field3", "metaDataTV"],
  // ],
  // searchConfigMulTVMap: [["genres", "genresTV"]],
  // searchConfigOmitKeyMap: [
  //   ["composer", "composer_missing"],
  //   ["writer", "writer_missing"],
  //   ["publisher", "publisher_missing"],
  //   ["producer", "producer_missing"],
  //   ["arranger", "arranger_missing"],
  // ],
});

export default {
  components: {},
  props: {
    advancedSearchData: {
      type: Object,
    },
    initSearchFilter: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        isModel: true,
      },

      account_id: "",
      status: "",
      accounted_period: "",
      order_month: "",
      order_date_start: convertDateYYYYMMDD(new Date()),
      order_date_end: convertDateYYYYMMDD(new Date()),
      shipping_date: "",
      is_shipped: "",
      order_reference: "",

      loading: false,
    };
  },
  mixins: [createAdvancedSearchModal(orderListAdvancedSearchConfig)],
  computed: {
    searchFilter: function () {
      return {
        ...ensureStringObjectFromKeys(
          this,
          orderListAdvancedSearchConfig.searchConfigStringKeys
        ),
      };
    },
  },
  methods: {
    onDateChange: function (name, value) {
      this[name] = value;
    },
    onTextFieldValueChange: function (name, value) {
      this[name] = value;
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onDropdownChange: function (name, value) {
      this[name] = value.value;
    },
    onGenreSelected: function (value) {
      this.genres = value?.map((e) => e.value).join(",");
    },
    onCheckboxChange: function (name, event) {
      this[name] = event.target.checked;
    },
    onSearch: async function () {
      if (this.isFilterEmpty()) {
        return;
      }
      // console.log({ "this.searchFilter": this.searchFilter });
      console.log({
        "advanced-search.vue:834 this.searchFilter": JSON.stringify(
          this.searchFilter,
          null,
          2
        ),
      });
      this.$emit("search", this.searchFilter);
    },
    onExport: async function () {
      //  const res=await TracksService.exportAdvancedSearch(this.searchFilter);
      console.log("res.data", res.data);
      FileDownload(res.data, "Track_Export.xlsx");
      this.onCancel();
    },
    filterEmptyError() {
      return `Please provide value to any one of these Fields - Artist, Title, Version, Track type, Digital right, Genres, Isrc error, Missing main product, Product track mismatch, Licence account, Main label, Any label, Royalty account, No contract, Playtime missing, Composer missing, Composer, Writer missing, Writer, Publisher missing, Publisher, Producer missing, Producer, Arranger missing, Arranger, Metadata value1, Metadata value2, Metadata value3, Track grid`;
    },
    isFilterEmpty() {
      let {
        account_id,
        status,
        accounted_period,
        order_month,
        order_date_start,
        order_date_end,
        shipping_date,
        is_shipped,
        order_reference,
      } = this;

      if (
        !account_id &&
        !status &&
        !accounted_period &&
        !order_month &&
        !order_date_start &&
        !order_date_end &&
        !shipping_date &&
        !is_shipped &&
        !order_reference
      ) {
        return true;
      }
      return false;
    },
  },
  //MARK: Methods
};
</script>

<style lang="scss" scoped>
.cmp-catalog-tracks-advanced_search {
  // .search--input {
  //   flex: 1;
  // }

  // .search--checkbox {
  //   min-width: 20px;
  //   margin-left: 4px;

  //   display: flex;
  //   flex-direction: column;
  //   justify-content: center;

  //   @media screen and (min-width: 320px) and (max-width: 480px) {
  //     padding-left: 0px;
  //     margin-left: 0px;

  //     .checkmark {
  //       margin-left: 10px;
  //     }
  //   }
  // }

  // .checkbox-container {
  //   .dt-checkbox-control {
  //     align-items: center;
  //     height: 30px;
  //     .dt-checkbox-label {
  //       flex: 1;
  //       padding-left: 10px;
  //     }
  //   }
  // }

  // .row-control {
  //   margin: 10px 0;
  //   .search--input {
  //     max-width: 100%;
  //   }
  // }
  // .date-control {
  //   .dt-input-box--container {
  //     flex: 1;
  //     &:first-child {
  //       padding-right: 10px;
  //     }
  //     &:last-child {
  //       padding-left: 10px;
  //     }
  //   }
  // }
}
</style>